export default __webpack_public_path__ + "static/media/16.22537388.JPG";